/**
 * generate course duration to be displayed in course detail with format
 * @param {string} duration course duration from API
 * @returns formatted course duration
 */
export const generateCourseDuration = (duration) => {
  const number = [];
  let durations = '';
  let text = [];

  duration.split('-').forEach((data) => {
    if (parseInt(data) || data == '0') {
      number.push(parseInt(data));
    } else {
      text.push(data);
    }
  });

  number &&
    number.forEach((time, index) => {
      if (time) {
        durations = durations + ' ' + number[index] + ' ' + text[index];
      }
    });

  return durations;
};

/**
 * remove duplicate testimoni and add link image of the person
 * @param {object[]} courseTestimonial testimoni data from api
 * @param {string} baseImageUrl base image from api
 * @returns formatted testimoni
 */
export const generateCourseTestimoni = (courseTestimonial, baseImageUrl) => {
  let formattedTestimoni;

  if (courseTestimonial[0]?.testimoni[0].review) {
    // delete duplicate review
    const testimonialWithoutDuplicate = courseTestimonial[0]?.testimoni.filter(
      (value, index, self) => index === self?.findIndex((item) => item._id === value._id)
    );

    // manipulate array from no duplicated element
    formattedTestimoni = testimonialWithoutDuplicate.map((row) => {
      return {
        ...row,
        fileImage: row.image === 'false' ? false : `${baseImageUrl}/uploads/courses/cover-outline/${row.image}`,
      };
    });
  }

  return formattedTestimoni;
};
